import IconBool from "components/IconBool";

const MQ2Table = ({item, items}) => {
    return (
        <>
            <td>
                <input
                    type="checkbox"
                    name="checkboxContainer"
                    key={item.id}
                    data-idx={item.id}
                    defaultChecked={items.current.chosen.includes(item.id)}
                    readOnly={true}
                />
            </td>
            <td>{item.name}</td>
            <td>{item.description}</td>
            <td>{item.model}</td>
            <td className="text-center">
                <div>{item.values.preference_sim || "-"}</div>
            </td>
            <td className="text-center">
                <div>{item.values.sim0_band || "-"}</div>
                <div>{item.values.sim1_band || "-"}</div>
            </td>
            <td className="text-center">
                <div>
                    <IconBool value={item.has.has_sim0_pin} classAdd="me-2" />
                    {item.values.sim0_pin === "-1" ? "-" : item.values.sim0_pin}
                </div>
                <div>
                    <IconBool value={item.has.has_sim1_pin} classAdd="me-2" />
                    {item.values.sim1_pin === "-1" ? "-" : item.values.sim1_pin}
                </div>
            </td>
            <td className="text-center">
                <div>
                    <IconBool value={item.has.has_sim0_apn_name} classAdd="me-2" />
                    {item.values.sim0_apn_name === "" ? "-" : item.values.sim0_apn_name}
                </div>
                <div>
                    <IconBool value={item.has.has_sim1_apn_name} classAdd="me-2" />
                    {item.values.sim1_apn_name === "" ? "-" : item.values.sim1_apn_name}
                </div>
            </td>
            <td className="text-center">
                <div>
                    <IconBool value={item.has.has_sim0_apn_user} classAdd="me-2" />
                    {item.values.sim0_apn_user === "" ? "-" : item.values.sim0_apn_user}
                </div>
                <div>
                    <IconBool value={item.has.has_sim1_apn_user} classAdd="me-2" />
                    {item.values.sim1_apn_user === "" ? "-" : item.values.sim1_apn_user}
                </div>
            </td>
            <td className="text-center">
                <div>
                    <IconBool value={item.has.has_sim0_apn_pass} classAdd="me-2" />
                    {item.values.sim0_apn_pass === "" ? "-" : item.values.sim0_apn_pass}
                </div>
                <div>
                    <IconBool value={item.has.has_sim1_apn_pass} classAdd="me-2" />
                    {item.values.sim1_apn_pass === "" ? "-" : item.values.sim1_apn_pass}
                </div>
            </td>
        </>
    );
};
export default MQ2Table;
